
import React, { useState, useEffect } from 'react';
import { ImageOptimizer } from '@/components/common/ImageOptimizer';

interface CompanyLogo {
  src: string;
  alt: string;
}

export const CompanyLogos = () => {
  const [activeLogoIndex, setActiveLogoIndex] = useState(0);
  
  const companyLogos: CompanyLogo[] = [
    {
      src: "/lovable-uploads/627e911d-3a7f-43f6-bf2e-6966e4e5aab1.png",
      alt: "Shiprocket"
    },
    {
      src: "/lovable-uploads/a71cb788-e630-4ab4-a552-8fb24944b53b.png",
      alt: "Sprinto"
    },
    {
      src: "/lovable-uploads/85add715-5da8-4fc5-84ae-fbd2f3620280.png",
      alt: "Astra"
    },
    {
      src: "/lovable-uploads/6f0cc1b1-9a90-4ce9-9373-c17c9d691ff1.png",
      alt: "Deepintent"
    },
    {
      src: "/lovable-uploads/c27f257f-763a-45c2-bb88-79f26317ace7.png",
      alt: "Egnyte"
    },
    {
      src: "/lovable-uploads/74985841-bd38-4fb1-aeaf-6072cf922ecf.png",
      alt: "Thoughtworks"
    },
    {
      src: "/lovable-uploads/382976cd-6fb9-4dfb-89b8-bd432c181e25.png",
      alt: "Fractal"
    },
    {
      src: "/lovable-uploads/18bd99a7-8dc0-4716-a539-c7e69d9fbf60.png",
      alt: "Biofourmis"
    },
    {
      src: "/lovable-uploads/354b74b2-bc4b-43dd-b6b4-16d4b9d58aec.png",
      alt: "Klenty"
    },
    {
      src: "/lovable-uploads/6c2ef51c-32c6-4ccb-ad73-0aeb37ee3581.png",
      alt: "PipeCandy"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLogoIndex((prevIndex) => (prevIndex + 1) % companyLogos.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-12 mb-6">
      <p className="text-sm text-brand-grey mb-6">TRUSTED BY INNOVATIVE COMPANIES</p>
      <div className="flex justify-center items-center h-16 relative">
        {companyLogos.map((logo, index) => (
          <div 
            key={index}
            className={`absolute transition-all duration-700 transform ${
              index === activeLogoIndex 
                ? 'opacity-100 scale-100 rotate-0' 
                : 'opacity-0 scale-90 rotate-10'
            }`}
          >
            <ImageOptimizer
              src={logo.src}
              alt={logo.alt}
              className="h-12 mx-2"
              width={100}
              height={40}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
